import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/**
 * HTTP Interceptor to add Accept-Language header to requests
 * it uses TranslateService to get the current language
 * and this way ensures the backend receives the correct language preference
 */

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private _translateService = inject(TranslateService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = this._translateService.currentLang || 'es';
    const modifiedReq = req.clone({
      setHeaders: {
        'Accept-Language': lang
      }
    });
    return next.handle(modifiedReq);
  }
}